import * as Api from '@/helpers/restApi'

export default {
  state: {
    ActivityList: null,
    ProductsListData: null,
    AddProductsList: null,
    AddProductsListFiltered: null,
    ShowProductAdder: false
  },
  getters: {
    getActivityList: state => state.ActivityList,
    getProductsListData: state => state.ProductsListData,
    getAddProductsListFiltered: state => state.AddProductsListFiltered,
    getShowProductAdder: state => state.ShowProductAdder
  },
  mutations: {
    SetM_MoveProductsList (state, val) {
      if (!val.type) {
        const temp = state.ProductsListData[val.evn.newIndex]
        state.ProductsListData[val.evn.newIndex] = state.ProductsListData[val.evn.oldIndex]
        state.ProductsListData[val.evn.oldIndex] = temp
      } else if (val.type) {
        const currentCategory = state.ProductsListData.find(item => {
          return item.UniversalTagId === val.itemId
        })

        state.ProductsListData.forEach(item => {
          if (item.UniversalTagId === val.itemId) {
            item = currentCategory
          }
        })
      }

      this.dispatch('SetA_MoveProduct')
    },
    SetM_MoveServiceList (state, val) {
      if (!val.type) {
        const temp = state.ProductsListData[val.evn.newIndex]
        state.ProductsListData[val.evn.newIndex] = state.ProductsListData[val.evn.oldIndex]
        state.ProductsListData[val.evn.oldIndex] = temp
      } else if (val.type) {
        const currentCategory = state.ProductsListData.find(item => {
          return item.UniversalTagId === val.itemId
        })

        state.ProductsListData.forEach(item => {
          if (item.UniversalTagId === val.itemId) {
            item = currentCategory
          }
        })
      }

      this.dispatch('SetA_MoveService')
    },
    SetM_MoveCategory (state, val) {
      const swapElements = (array, index1, index2) => {
        const temp = array[index1]
        array[index1] = array[index2]
        array[index2] = temp

        return array
      }
      state.MainBannersData = swapElements(state.MainBannersData, val.newIndex, val.oldIndex)
      this.dispatch('SetA_MoveCategory')
    },
    SetM_UpdateProductsListData (state, val) {
      state.ProductsListData = val
    },
    SetM_ShowProductAdder (state, val) {
      state.ShowProductAdder = val
    },
    SetM_UpdateActivityList (state, val) {
      state.ActivityList = val
    },
    SetM_UpdateAddProductList (state, val) {
      state.AddProductsList = val
      state.AddProductsListFiltered = val
    },
    SetM_SearchAddProductList (state, val) {
      state.AddProductsListFiltered = state.AddProductsList.filter(item => {
        return item.Name.toLowerCase().includes(val.toLowerCase())
      })
    }

  },
  actions: {
    SetA_ActivityList ({ state, dispatch, commit }) {
      Api.getApi({
        url: '/api/UniversalTags/GetMainPageUniversalTags'
      })
        .then((data) => {
          if (data.Succeeded) {
            commit('SetM_UpdateActivityList', data.Data)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    SetA_ProductsListProduction ({ state, commit, dispatch }, id) {
      Api.getApi({
        url: `/api/Products/AllProductsAndUniversalTagChildsByUniversalTag/${id}`
      })
        .then((data) => {
          if (data.Succeeded) {
            commit('SetM_UpdateProductsListData', data.Data)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    SetA_ProductsListServices ({ state, dispatch, commit }, id) {
      Api.getApi({
        url: `/api/Utilities/AllUtilitiesAndUniversalTagChildsByUniversalTag/${id}`
      })
        .then((data) => {
          if (data.Succeeded) {
            commit('SetM_UpdateProductsListData', data.Data)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    SetA_PublishProduct ({ state, dispatch, commit }, obj) {
      Api.putApi({
        url: `/api/Products/TooglePublish/${obj.Id}`,
        payload: {
          Value: obj.Value
        }
      })
        .then((data) => {
          if (data.Succeeded) {
            dispatch('SetA_ProductsListProduction', obj?.Active)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    SetA_PublishService ({ state, dispatch, commit }, obj) {
      Api.putApi({
        url: `/api/Utilities/TooglePublish/${obj.Id}`,
        payload: {
          Value: obj.Value
        }
      })
        .then((data) => {
          if (data.Succeeded) {
            dispatch('SetA_ProductsListServices', obj?.Active)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    SetA_AddSubcategoryProduction ({ state, dispatch, commit }, obj) {
      Api.postApi({
        url: '/api/UniversalTags',
        payload: obj
      })
        .then((data) => {
          if (data.Succeeded) {
            dispatch('SetA_ProductsListProduction', obj.ParentTagId)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    SetA_AddCategory ({ state, dispatch, commit }, obj) {
      Api.postApi({
        url: '/api/UniversalTags',
        payload: obj
      })
        .then((data) => {
          if (data.Succeeded) {
            dispatch('SetA_ActivityList')
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    SetA_SaveNameCategoryProduct ({ state, dispatch, commit }, obj) {
      Api.putApi({
        url: `/api/UniversalTags/RenameTag/${obj.Id}`,
        payload: {
          Id: obj.Id,
          Name: obj.Name
        }
      })
        .then((data) => {
          if (data.Succeeded) {
            dispatch('SetA_ProductsListProduction', obj.ParentTagId)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    SetA_SaveNameCategoryService ({ state, dispatch, commit }, obj) {
      Api.putApi({
        url: `/api/UniversalTags/RenameTag/${obj.Id}`,
        payload: {
          Id: obj.Id,
          Name: obj.Name
        }
      })
        .then((data) => {
          if (data.Succeeded) {
            dispatch('SetA_ProductsListServices', obj.ParentTagId)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    SetA_SaveNameCategory ({ state, dispatch, commit }, obj) {
      Api.putApi({
        url: `/api/UniversalTags/RenameTag/${obj.Id}`,
        payload: {
          Id: obj.Id,
          Name: obj.Name
        }
      })
        .then((data) => {
          if (data.Succeeded) {
            dispatch('SetA_ActivityList')
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    SetA_AddSubcategoryService ({ state, dispatch, commit }, obj) {
      Api.postApi({
        url: '/api/UniversalTags',
        payload: obj
      })
        .then((data) => {
          if (data.Succeeded) {
            dispatch('SetA_ProductsListServices', obj.ParentTagId)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    SetA_AddProductSubCategoryProduction ({ state, dispatch, commit }, obj) {
      Api.putApi({
        url: `/api/Products/SetProductsUniversalTags/${obj.Id}`,
        payload: {
          Values: obj.Values
        }
      })
        .then((data) => {
          if (data.Succeeded) {
            dispatch('SetA_ProductsListProduction', obj.ParentTagId)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    SetA_AddProductSubCategorySrvice ({ state, dispatch, commit }, obj) {
      Api.putApi({
        url: `/api/Utilities/SetUtilitiesUniversalTags/${obj.Id}`,
        payload: {
          Values: obj.Values
        }
      })
        .then((data) => {
          if (data.Succeeded) {
            dispatch('SetA_ProductsListServices', obj.ParentTagId)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    SetA_ListProduction ({ state, commit, dispatch }, id) {
      Api.getApi({
        url: '/api/Products/GetEmptyUniversalTagSubChildProducts'
      })
        .then((data) => {
          if (data.Succeeded) {
            commit('SetM_UpdateAddProductList', data.Data)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    SetA_ListService ({ state, commit, dispatch }) {
      Api.getApi({
        url: '/api/Utilities/GetEmptyUniversalTagSubChildUtilities'
      })
        .then((data) => {
          if (data.Succeeded) {
            commit('SetM_UpdateAddProductList', data.Data)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    SetA_DeleteSubCategoryProduction ({ state, dispatch, commit }, obj) {
      Api.deleteApi({
        url: `/api/UniversalTags/${obj?.Id}`
      })
        .then((data) => {
          if (data.Succeeded) {
            dispatch('SetA_ProductsListProduction', obj?.Active)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    SetA_DeleteSubCategoryService ({ state, dispatch, commit }, obj) {
      Api.deleteApi({
        url: `/api/UniversalTags/${obj?.Id}`
      })
        .then((data) => {
          if (data.Succeeded) {
            dispatch('SetA_ProductsListServices', obj?.Active)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    SetA_DeleteProductCategoryProduction ({ state, dispatch, commit }, obj) {
      Api.putApi({
        url: `/api/Products/RemoveUniversalTagChild/${obj?.Id}`
      })
        .then((data) => {
          if (data.Succeeded) {
            dispatch('SetA_ProductsListProduction', obj?.Active)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    SetA_DeleteProductCategoryService ({ state, dispatch, commit }, obj) {
      Api.putApi({
        url: `/api/Utilities/RemoveUniversalTagSubChild/${obj?.Id}`
      })
        .then((data) => {
          if (data.Succeeded) {
            dispatch('SetA_ProductsListServices', obj?.Active)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    SetA_DeleteCategory ({ state, dispatch, commit }, id) {
      Api.deleteApi({
        url: `/api/UniversalTags/${id}`
      })
        .then((data) => {
          if (data.Succeeded) {
            dispatch('SetA_ActivityList')
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    SetA_MoveProduct ({ state, dispatch, commit }) {
      Api.postApi({
        url: '/api/Products/SetProductsAndUniversalTagsIndexes',
        payload: state.ProductsListData
      })
        .then((data) => {
          if (!data.Succeeded) {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    // SetA_MoveCategory ({ state, dispatch, commit }) {
    //   Api.postApi({
    //     url: '/UniversalTags/SetIndexes',
    //     payload: state.ActivityList.Childs
    //   })
    //     .then((data) => {
    //       if (!data.Succeeded) {
    //         dispatch('setShowErrorModal', data)
    //       }
    //     })
    // },
    SetA_MoveService ({ state, dispatch, commit }) {
      Api.postApi({
        url: '/api/Utilities/SetUtilitiesAndUniversalTagsIndexes',
        payload: state.ProductsListData
      })
        .then((data) => {
          if (!data.Succeeded) {
            dispatch('setShowErrorModal', data)
          }
        })
    }
  }
}
